import { ApiConfiguration } from './types'

const apiConfiguration: ApiConfiguration = Object.freeze({
  url: (process.env['REACT_APP_API_URL'] as string) || '',
})

export default apiConfiguration
